import { render, staticRenderFns } from "./BuyNowPayLaterTable.vue?vue&type=template&id=71d1ea6a&scoped=true"
import script from "./BuyNowPayLaterTable.vue?vue&type=script&lang=js"
export * from "./BuyNowPayLaterTable.vue?vue&type=script&lang=js"
import style0 from "./BuyNowPayLaterTable.vue?vue&type=style&index=0&id=71d1ea6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d1ea6a",
  null
  
)

export default component.exports